import Commencer from "@/views/private/questionnaire/Commencer.vue";
import Question from "@/views/private/questionnaire/Question.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/questionnaire/:type",
        name: RouteEnum.TEST_COMMENCER,
        component: Commencer
    },
    {
        path: "/questionnaire/:type/question",
        name: RouteEnum.TEST_QUESTION,
        component: Question
    },
]
